import {
  FeeScheduleMappingHandler,
  IBaseMigrationFeeSchedule,
} from '../../../mappings/fee-schedules';
import {
  FeeScheduleSourceEntity,
  IOasisFeeSchedule,
  OasisFeeSchedule,
} from '../../source/entities/fee-schedule';

export class OasisFeeScheduleMappingHandler extends FeeScheduleMappingHandler<
  OasisFeeSchedule,
  FeeScheduleSourceEntity
> {
  override sourceEntity = new FeeScheduleSourceEntity();
  translateFn = (record: IOasisFeeSchedule): IBaseMigrationFeeSchedule => ({
    ...record,
  });
}
